/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { NamedCertificateCategory } from '../model';
// @ts-ignore
import type { X509CertificateDetails } from '../model';
/**
 * CertificateSelectionApi - axios parameter creator
 * @export
 */
export const CertificateSelectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * When the property \"autoSelectEncryptionCerts\" is activated for a user, certificates that meet the following criteria will be returned: they must be valid for encryption, trusted, not revoked, and have a matching email address to that of the user.  Certificates that are inherited, manually selected, or those that lack PKI validity will not be included in the list of automatically selected certificates. 
         * @summary Get all automatically selected encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/getAutoSelectedEncryptionCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all valid and trusted encryption certificate for a user. 
         * @summary Get all encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetEncryptionCertificatesForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetEncryptionCertificatesForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/getEncryptionCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the explicitly set certificate for a domain.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerGetExplicitCertificatesForDomain', 'domain', domain)
            const localVarPath = `/api/certificate/selection/getExplicitCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the explicitly set certificate for a user.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetExplicitCertificatesForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/getExplicitCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the explicitly set certificate for the global settings.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for the global settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesGlobal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/selection/getExplicitCertificatesGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all inherited certificate for a domain.  Certificates are inherited from the global settings. 
         * @summary Get all inherited certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedCertificatesForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedCertificatesForDomain', 'domain', domain)
            const localVarPath = `/api/certificate/selection/getInheritedCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all inherited certificate for a user.  Certificates are inherited from the domain of the user. 
         * @summary Get all inherited certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedCertificatesForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedCertificatesForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/getInheritedCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all inherited certificate for a domain from the certificate category. 
         * @summary Get all inherited named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedNamedCertificatesForDomain: async (domain: string, category: NamedCertificateCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedNamedCertificatesForDomain', 'domain', domain)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedNamedCertificatesForDomain', 'category', category)
            const localVarPath = `/api/certificate/selection/getInheritedNamedCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all inherited certificate for a user from the certificate category. 
         * @summary Get all inherited named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedNamedCertificatesForUser: async (email: string, category: NamedCertificateCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedNamedCertificatesForUser', 'email', email)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerGetInheritedNamedCertificatesForUser', 'category', category)
            const localVarPath = `/api/certificate/selection/getInheritedNamedCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all certificate for a domain from the certificate category. 
         * @summary Get all named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForDomain: async (domain: string, category: NamedCertificateCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerGetNamedCertificatesForDomain', 'domain', domain)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerGetNamedCertificatesForDomain', 'category', category)
            const localVarPath = `/api/certificate/selection/getNamedCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all certificate for a domain from the global settings. 
         * @summary Get all named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForGlobal: async (category: NamedCertificateCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerGetNamedCertificatesForGlobal', 'category', category)
            const localVarPath = `/api/certificate/selection/getNamedCertificatesGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all certificate for a user from the certificate category. 
         * @summary Get all named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForUser: async (email: string, category: NamedCertificateCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetNamedCertificatesForUser', 'email', email)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerGetNamedCertificatesForUser', 'category', category)
            const localVarPath = `/api/certificate/selection/getNamedCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the signing certificate for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForDomain: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerGetSigningCertificateForDomain', 'domain', domain)
            const localVarPath = `/api/certificate/selection/getSigningCertificateForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the signing certificate for global
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForGlobal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/selection/getSigningCertificateForGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user\'s signing certificate.  A signing certificate always includes a private key linked to it, typically indicated by a key alias being set. If the user has enabled the option \"alwaysUseFreshestSigningCert\", the most recent signing certificate will be automatically chosen and provided. If \"alwaysUseFreshestSigningCert\" is not set and a signing certificate has been manually selected and remains valid, the manually selected certificate will be returned.  If there is no manually selected certificate or if the selected certificate is no longer valid, the system will automatically select and return the latest signing certificate. If no valid signing certificate is available, an empty result will be returned. 
         * @summary Get the signing certificate for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerGetSigningCertificateForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/getSigningCertificateForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set certificates for a domain. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the domain will be cleared. 
         * @summary Set certificates for a domain
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesForDomain: async (domain: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerSetExplicitCertificatesForDomain', 'domain', domain)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetExplicitCertificatesForDomain', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setExplicitCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set certificates for a user. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the user will be cleared. 
         * @summary Set certificates for a user
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesForUser: async (email: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerSetExplicitCertificatesForUser', 'email', email)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetExplicitCertificatesForUser', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setExplicitCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set certificates for the global settings. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the global settings will be cleared. 
         * @summary Set certificates for the global settings
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesGlobal: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetExplicitCertificatesGlobal', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setExplicitCertificatesGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the domain will be cleared. 
         * @summary Set named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesForDomain: async (domain: string, category: NamedCertificateCategory, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForDomain', 'domain', domain)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForDomain', 'category', category)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForDomain', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setNamedCertificatesForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the user will be cleared. 
         * @summary Set named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesForUser: async (email: string, category: NamedCertificateCategory, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForUser', 'email', email)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForUser', 'category', category)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesForUser', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setNamedCertificatesForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the global settings will be cleared. 
         * @summary Set named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesGlobal: async (category: NamedCertificateCategory, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesGlobal', 'category', category)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateSelectionControllerSetNamedCertificatesGlobal', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/selection/setNamedCertificatesGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the signing certificate for a domain
         * @param {string} domain 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForDomain: async (domain: string, thumbprint?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('certificateSelectionControllerSetSigningCertificateForDomain', 'domain', domain)
            const localVarPath = `/api/certificate/selection/setSigningCertificateForDomain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the signing certificate for global
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForGlobal: async (thumbprint?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/selection/setSigningCertificateForGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Explicitly sets the signing certificate for a user. It\'s required that the signing certificate exists and is associated with a private key.  Whether this signing certificate is actually used depends on various conditions. The signing certificate will not be used if it is not suitable for signing, lacks trust, is revoked, not valid for email purposes, or if the user has the \"alwaysUseFreshestSigningCert\" option enabled, and a more recent signing certificate is accessible.  if the thumbprint is not set, the selected signing certificate will be cleared. 
         * @summary Set the signing certificate for a user
         * @param {string} email 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForUser: async (email: string, thumbprint?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateSelectionControllerSetSigningCertificateForUser', 'email', email)
            const localVarPath = `/api/certificate/selection/setSigningCertificateForUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificateSelectionApi - functional programming interface
 * @export
 */
export const CertificateSelectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificateSelectionApiAxiosParamCreator(configuration)
    return {
        /**
         * When the property \"autoSelectEncryptionCerts\" is activated for a user, certificates that meet the following criteria will be returned: they must be valid for encryption, trusted, not revoked, and have a matching email address to that of the user.  Certificates that are inherited, manually selected, or those that lack PKI validity will not be included in the list of automatically selected certificates. 
         * @summary Get all automatically selected encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all valid and trusted encryption certificate for a user. 
         * @summary Get all encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetEncryptionCertificatesForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetEncryptionCertificatesForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetEncryptionCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the explicitly set certificate for a domain.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetExplicitCertificatesForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetExplicitCertificatesForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetExplicitCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the explicitly set certificate for a user.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetExplicitCertificatesForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetExplicitCertificatesForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetExplicitCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the explicitly set certificate for the global settings.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for the global settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetExplicitCertificatesGlobal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetExplicitCertificatesGlobal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetExplicitCertificatesGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all inherited certificate for a domain.  Certificates are inherited from the global settings. 
         * @summary Get all inherited certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetInheritedCertificatesForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetInheritedCertificatesForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetInheritedCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all inherited certificate for a user.  Certificates are inherited from the domain of the user. 
         * @summary Get all inherited certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetInheritedCertificatesForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetInheritedCertificatesForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetInheritedCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all inherited certificate for a domain from the certificate category. 
         * @summary Get all inherited named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetInheritedNamedCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all inherited certificate for a user from the certificate category. 
         * @summary Get all inherited named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetInheritedNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetInheritedNamedCertificatesForUser(email, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetInheritedNamedCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all certificate for a domain from the certificate category. 
         * @summary Get all named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetNamedCertificatesForDomain(domain, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetNamedCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all certificate for a domain from the global settings. 
         * @summary Get all named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetNamedCertificatesForGlobal(category: NamedCertificateCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetNamedCertificatesForGlobal(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetNamedCertificatesForGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all certificate for a user from the certificate category. 
         * @summary Get all named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetNamedCertificatesForUser(email, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetNamedCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the signing certificate for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetSigningCertificateForDomain(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetSigningCertificateForDomain(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetSigningCertificateForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the signing certificate for global
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetSigningCertificateForGlobal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetSigningCertificateForGlobal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetSigningCertificateForGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the user\'s signing certificate.  A signing certificate always includes a private key linked to it, typically indicated by a key alias being set. If the user has enabled the option \"alwaysUseFreshestSigningCert\", the most recent signing certificate will be automatically chosen and provided. If \"alwaysUseFreshestSigningCert\" is not set and a signing certificate has been manually selected and remains valid, the manually selected certificate will be returned.  If there is no manually selected certificate or if the selected certificate is no longer valid, the system will automatically select and return the latest signing certificate. If no valid signing certificate is available, an empty result will be returned. 
         * @summary Get the signing certificate for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerGetSigningCertificateForUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerGetSigningCertificateForUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerGetSigningCertificateForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set certificates for a domain. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the domain will be cleared. 
         * @summary Set certificates for a domain
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetExplicitCertificatesForDomain(domain: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetExplicitCertificatesForDomain(domain, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetExplicitCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set certificates for a user. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the user will be cleared. 
         * @summary Set certificates for a user
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetExplicitCertificatesForUser(email: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetExplicitCertificatesForUser(email, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetExplicitCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set certificates for the global settings. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the global settings will be cleared. 
         * @summary Set certificates for the global settings
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetExplicitCertificatesGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the domain will be cleared. 
         * @summary Set named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetNamedCertificatesForDomain(domain, category, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetNamedCertificatesForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the user will be cleared. 
         * @summary Set named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetNamedCertificatesForUser(email, category, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetNamedCertificatesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the global settings will be cleared. 
         * @summary Set named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetNamedCertificatesGlobal(category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetNamedCertificatesGlobal(category, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetNamedCertificatesGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the signing certificate for a domain
         * @param {string} domain 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetSigningCertificateForDomain(domain: string, thumbprint?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetSigningCertificateForDomain(domain, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetSigningCertificateForDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the signing certificate for global
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetSigningCertificateForGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Explicitly sets the signing certificate for a user. It\'s required that the signing certificate exists and is associated with a private key.  Whether this signing certificate is actually used depends on various conditions. The signing certificate will not be used if it is not suitable for signing, lacks trust, is revoked, not valid for email purposes, or if the user has the \"alwaysUseFreshestSigningCert\" option enabled, and a more recent signing certificate is accessible.  if the thumbprint is not set, the selected signing certificate will be cleared. 
         * @summary Set the signing certificate for a user
         * @param {string} email 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateSelectionControllerSetSigningCertificateForUser(email: string, thumbprint?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateSelectionControllerSetSigningCertificateForUser(email, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateSelectionApi.certificateSelectionControllerSetSigningCertificateForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificateSelectionApi - factory interface
 * @export
 */
export const CertificateSelectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificateSelectionApiFp(configuration)
    return {
        /**
         * When the property \"autoSelectEncryptionCerts\" is activated for a user, certificates that meet the following criteria will be returned: they must be valid for encryption, trusted, not revoked, and have a matching email address to that of the user.  Certificates that are inherited, manually selected, or those that lack PKI validity will not be included in the list of automatically selected certificates. 
         * @summary Get all automatically selected encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all valid and trusted encryption certificate for a user. 
         * @summary Get all encryption certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetEncryptionCertificatesForUser(email: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetEncryptionCertificatesForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the explicitly set certificate for a domain.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesForDomain(domain: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetExplicitCertificatesForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the explicitly set certificate for a user.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesForUser(email: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetExplicitCertificatesForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the explicitly set certificate for the global settings.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
         * @summary Get all explicitly set certificates for the global settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetExplicitCertificatesGlobal(options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetExplicitCertificatesGlobal(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all inherited certificate for a domain.  Certificates are inherited from the global settings. 
         * @summary Get all inherited certificates for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedCertificatesForDomain(domain: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetInheritedCertificatesForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all inherited certificate for a user.  Certificates are inherited from the domain of the user. 
         * @summary Get all inherited certificates for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedCertificatesForUser(email: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetInheritedCertificatesForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all inherited certificate for a domain from the certificate category. 
         * @summary Get all inherited named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all inherited certificate for a user from the certificate category. 
         * @summary Get all inherited named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetInheritedNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetInheritedNamedCertificatesForUser(email, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all certificate for a domain from the certificate category. 
         * @summary Get all named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetNamedCertificatesForDomain(domain, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all certificate for a domain from the global settings. 
         * @summary Get all named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForGlobal(category: NamedCertificateCategory, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetNamedCertificatesForGlobal(category, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all certificate for a user from the certificate category. 
         * @summary Get all named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerGetNamedCertificatesForUser(email, category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the signing certificate for a domain
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForDomain(domain: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerGetSigningCertificateForDomain(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the signing certificate for global
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForGlobal(options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerGetSigningCertificateForGlobal(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the user\'s signing certificate.  A signing certificate always includes a private key linked to it, typically indicated by a key alias being set. If the user has enabled the option \"alwaysUseFreshestSigningCert\", the most recent signing certificate will be automatically chosen and provided. If \"alwaysUseFreshestSigningCert\" is not set and a signing certificate has been manually selected and remains valid, the manually selected certificate will be returned.  If there is no manually selected certificate or if the selected certificate is no longer valid, the system will automatically select and return the latest signing certificate. If no valid signing certificate is available, an empty result will be returned. 
         * @summary Get the signing certificate for a user
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerGetSigningCertificateForUser(email: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerGetSigningCertificateForUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Set certificates for a domain. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the domain will be cleared. 
         * @summary Set certificates for a domain
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesForDomain(domain: string, requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetExplicitCertificatesForDomain(domain, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Set certificates for a user. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the user will be cleared. 
         * @summary Set certificates for a user
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesForUser(email: string, requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetExplicitCertificatesForUser(email, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Set certificates for the global settings. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the global settings will be cleared. 
         * @summary Set certificates for the global settings
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the domain will be cleared. 
         * @summary Set named certificates for a domain
         * @param {string} domain 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetNamedCertificatesForDomain(domain, category, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the user will be cleared. 
         * @summary Set named certificates for a user
         * @param {string} email 
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetNamedCertificatesForUser(email, category, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * If the list if thumbprints is empty, the named list of certificates for the global settings will be cleared. 
         * @summary Set named certificates for the global settings
         * @param {NamedCertificateCategory} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetNamedCertificatesGlobal(category: NamedCertificateCategory, requestBody: Array<string>, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateSelectionControllerSetNamedCertificatesGlobal(category, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the signing certificate for a domain
         * @param {string} domain 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForDomain(domain: string, thumbprint?: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerSetSigningCertificateForDomain(domain, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the signing certificate for global
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint?: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * Explicitly sets the signing certificate for a user. It\'s required that the signing certificate exists and is associated with a private key.  Whether this signing certificate is actually used depends on various conditions. The signing certificate will not be used if it is not suitable for signing, lacks trust, is revoked, not valid for email purposes, or if the user has the \"alwaysUseFreshestSigningCert\" option enabled, and a more recent signing certificate is accessible.  if the thumbprint is not set, the selected signing certificate will be cleared. 
         * @summary Set the signing certificate for a user
         * @param {string} email 
         * @param {string} [thumbprint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateSelectionControllerSetSigningCertificateForUser(email: string, thumbprint?: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateSelectionControllerSetSigningCertificateForUser(email, thumbprint, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificateSelectionApi - object-oriented interface
 * @export
 * @class CertificateSelectionApi
 * @extends {BaseAPI}
 */
export class CertificateSelectionApi extends BaseAPI {
    /**
     * When the property \"autoSelectEncryptionCerts\" is activated for a user, certificates that meet the following criteria will be returned: they must be valid for encryption, trusted, not revoked, and have a matching email address to that of the user.  Certificates that are inherited, manually selected, or those that lack PKI validity will not be included in the list of automatically selected certificates. 
     * @summary Get all automatically selected encryption certificates for a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetAutoSelectedEncryptionCertificatesForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all valid and trusted encryption certificate for a user. 
     * @summary Get all encryption certificates for a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetEncryptionCertificatesForUser(email: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetEncryptionCertificatesForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the explicitly set certificate for a domain.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
     * @summary Get all explicitly set certificates for a domain
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetExplicitCertificatesForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetExplicitCertificatesForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the explicitly set certificate for a user.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
     * @summary Get all explicitly set certificates for a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetExplicitCertificatesForUser(email: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetExplicitCertificatesForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the explicitly set certificate for the global settings.  Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked. 
     * @summary Get all explicitly set certificates for the global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetExplicitCertificatesGlobal(options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetExplicitCertificatesGlobal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all inherited certificate for a domain.  Certificates are inherited from the global settings. 
     * @summary Get all inherited certificates for a domain
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetInheritedCertificatesForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetInheritedCertificatesForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all inherited certificate for a user.  Certificates are inherited from the domain of the user. 
     * @summary Get all inherited certificates for a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetInheritedCertificatesForUser(email: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetInheritedCertificatesForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all inherited certificate for a domain from the certificate category. 
     * @summary Get all inherited named certificates for a domain
     * @param {string} domain 
     * @param {NamedCertificateCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetInheritedNamedCertificatesForDomain(domain, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all inherited certificate for a user from the certificate category. 
     * @summary Get all inherited named certificates for a user
     * @param {string} email 
     * @param {NamedCertificateCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetInheritedNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetInheritedNamedCertificatesForUser(email, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all certificate for a domain from the certificate category. 
     * @summary Get all named certificates for a domain
     * @param {string} domain 
     * @param {NamedCertificateCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetNamedCertificatesForDomain(domain, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all certificate for a domain from the global settings. 
     * @summary Get all named certificates for the global settings
     * @param {NamedCertificateCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetNamedCertificatesForGlobal(category: NamedCertificateCategory, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetNamedCertificatesForGlobal(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all certificate for a user from the certificate category. 
     * @summary Get all named certificates for a user
     * @param {string} email 
     * @param {NamedCertificateCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetNamedCertificatesForUser(email, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the signing certificate for a domain
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetSigningCertificateForDomain(domain: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetSigningCertificateForDomain(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the signing certificate for global
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetSigningCertificateForGlobal(options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetSigningCertificateForGlobal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the user\'s signing certificate.  A signing certificate always includes a private key linked to it, typically indicated by a key alias being set. If the user has enabled the option \"alwaysUseFreshestSigningCert\", the most recent signing certificate will be automatically chosen and provided. If \"alwaysUseFreshestSigningCert\" is not set and a signing certificate has been manually selected and remains valid, the manually selected certificate will be returned.  If there is no manually selected certificate or if the selected certificate is no longer valid, the system will automatically select and return the latest signing certificate. If no valid signing certificate is available, an empty result will be returned. 
     * @summary Get the signing certificate for a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerGetSigningCertificateForUser(email: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerGetSigningCertificateForUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set certificates for a domain. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the domain will be cleared. 
     * @summary Set certificates for a domain
     * @param {string} domain 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetExplicitCertificatesForDomain(domain: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetExplicitCertificatesForDomain(domain, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set certificates for a user. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the user will be cleared. 
     * @summary Set certificates for a user
     * @param {string} email 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetExplicitCertificatesForUser(email: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetExplicitCertificatesForUser(email, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set certificates for the global settings. Whether the certificates are used for encryption depends on a number of factors like whether the certificate is valid for email encryption, is trusted and not revoked.  If the list if thumbprints is empty, the explicitly list of certificates for the global settings will be cleared. 
     * @summary Set certificates for the global settings
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetExplicitCertificatesGlobal(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If the list if thumbprints is empty, the named list of certificates for the domain will be cleared. 
     * @summary Set named certificates for a domain
     * @param {string} domain 
     * @param {NamedCertificateCategory} category 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetNamedCertificatesForDomain(domain: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetNamedCertificatesForDomain(domain, category, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If the list if thumbprints is empty, the named list of certificates for the user will be cleared. 
     * @summary Set named certificates for a user
     * @param {string} email 
     * @param {NamedCertificateCategory} category 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetNamedCertificatesForUser(email: string, category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetNamedCertificatesForUser(email, category, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If the list if thumbprints is empty, the named list of certificates for the global settings will be cleared. 
     * @summary Set named certificates for the global settings
     * @param {NamedCertificateCategory} category 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetNamedCertificatesGlobal(category: NamedCertificateCategory, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetNamedCertificatesGlobal(category, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the signing certificate for a domain
     * @param {string} domain 
     * @param {string} [thumbprint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetSigningCertificateForDomain(domain: string, thumbprint?: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetSigningCertificateForDomain(domain, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the signing certificate for global
     * @param {string} [thumbprint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint?: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetSigningCertificateForGlobal(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Explicitly sets the signing certificate for a user. It\'s required that the signing certificate exists and is associated with a private key.  Whether this signing certificate is actually used depends on various conditions. The signing certificate will not be used if it is not suitable for signing, lacks trust, is revoked, not valid for email purposes, or if the user has the \"alwaysUseFreshestSigningCert\" option enabled, and a more recent signing certificate is accessible.  if the thumbprint is not set, the selected signing certificate will be cleared. 
     * @summary Set the signing certificate for a user
     * @param {string} email 
     * @param {string} [thumbprint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateSelectionApi
     */
    public certificateSelectionControllerSetSigningCertificateForUser(email: string, thumbprint?: string, options?: RawAxiosRequestConfig) {
        return CertificateSelectionApiFp(this.configuration).certificateSelectionControllerSetSigningCertificateForUser(email, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }
}

